<template>
<div class="box-labour">
    <div class="nav">
        <router-link to="HumanDirectory"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        劳动用工管理
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="issueContent">
        <div>
            <p class="titleClass">1. 劳动合同变更</p>
            <img v-show="addShowJia" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia()">
            <img v-show="addShowXia" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia()">
        </div>
        <div v-for="(item, i) in dataList" :key="i" v-show="showContent">
            <p class="titleClass titleCotent">{{item.title}}</p>
            <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(i)">
        </div>
        <div>
            <p class="titleClass">2. 三方协议签订流程</p>
            <img src="../../assets/you.png" alt="" class="ImgClass" @click="addAgreement">
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            addShowJia: true,
            addShowXia: false,
            showContent: false,
            dataList: [{
                title: "1.1 变更类型"
            }, {
                title: "1.2 变更流程"
            }]
        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "444"
                }
            })
        },
        addGetJia() {
            this.addShowXia = true;
            this.showContent = true;
            this.addShowJia = false;
        },
        addGetXia() {
            this.addShowXia = false;
            this.showContent = false;
            this.addShowJia = true;
        },
        addGetContent(i) {
            if (i == 0) {
                this.$router.push({
                    name: 'LabourParticulars',
                    params: {
                        code: '89'
                    }
                })
            } else if (i == 1) {
                this.$router.push({
                    name: 'LabourParticulars',
                    params: {
                        code: '99'
                    }
                })
            }
        },
        addAgreement() {
            this.$router.push({
                name: 'LabourParticulars',
                params: {
                    code: '79'
                }
            })
        }
    }
};
</script>

<style scoped>
.box-labour {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.issueContent {
    width: 90%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
    border-radius: 10px;
    overflow: hidden;
}

.issueContent div {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
    width: 86%;
    float: left;
    color: #838383;
    margin: 18px 0 18px 10px;
}

.issueContent div .ImgClassDian {
    width: 18px !important;
}

.issueContent div .titleCotent {
    width: 80% !important;
    margin-left: 24px !important;
    font-size: 15px;
}

.issueContent div img {
    width: 21px;
    float: right;
    margin: 18px 10px 18px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Labour/labour.vue